let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5zLU3")).then(() => parcelRequire('6nGVD'));